const Liveusers = (state = [], action) => {
    switch (action.type) {
        case 'ADMIN_LIVEUSERS_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default Liveusers